export default {
  'meta': {
    'langName': 'FRANCAIS',
    'lang': 'Français'
  },
  'title': 'RAPPEL PRODUIT PANIER DE BASKET B900 BOX NBA TARMAK',
  'description': 'Bonjour,\n\nVous avez effectué l’achat d’un panier de basket Tarmak B900 BOX NBA et nous vous en remercions.\n\nDans le cadre de notre engagement constant pour la qualité et la sécurité de nos produits, les équipes DECATHLON Basket ont identifié un risque de chute verticale du poteau dans le cas où la manivelle de réglage en hauteur serait enlevée et le produit manipulé ou utilisé.\n\nNous vous proposons de répondre aux questions suivantes afin de vous apporter la solution de mise en sécurité de votre produit.\n\nNous nous excusons pour la gêne occasionnée et vous remercions de votre confiance.\n\nDECATHLON',
  'emailConfirmation': {
    'title': 'Tout d’abord, pouvez-vous nous confirmer votre adresse mail et pays de résidence :'
  },
  'fields': {
    'country': 'Pays',
    'address': 'Adresse mail',
    'email': 'Adresse mail',
    'phonePrefix': 'Indicatif numéro de téléphone',
    'phone': 'Numéro de Téléphone',
    'validations': {
      'phoneOrEmail': 'Merci de renseigner au minimum une adresse email OU un numéro de téléphone',
      'email': 'Veuillez introduire une adresse email valide',
      'phone': 'Veuillez introduire un numéro de téléphone valide'
    },
    'firstName': 'Nom',
    'lastName': 'Prénom',
    'deliveryAddress': 'Adresse de livraison',
    'additionalAddress': 'Complément d\'adresse',
    'city': 'Ville',
    'zip': 'Code postal ',
    'choose': 'Choisir',
    'required': 'Ce champ est requis'
  },
  'ownerCheck': {
    'title': 'Etes-vous toujours en possession d’un ou plusieurs paniers de basket B900 BOX NBA ?'
  },
  'yes': 'OUI',
  'no': 'NON',
  'ownerChanged': {
    'title': 'Avez-vous les coordonnées du ou des propriétaires actuels ?',
    'confirmation': 'M/Mme.\n\nNous vous remercions pour votre participation à cette démarche qualité. \n\nNous nous excusons pour la gêne occasionnée et vous remercions de votre confiance.\n\nDECATHLON'
  },
  'recall': {
    'title': 'Indiquez nous la quantité de paniers de basket que vous avez selon le type de manivelle installée',
    'descriptionRed': 'Panier de basket avec manivelle rouge amovible',
    'descriptionBlack': 'Panier de basket avec manivelle noire fixe',
    'quantity': 'Quantité',
    'notConcerned': 'M/Mme.\n\nNous vous remercions de votre participation à cette démarche qualité. \n\nVous pouvez être rassuré•e, votre panier de basket Tarmak B900 BOX NBA n’est pas concerné par la démarche de rappel. Il peut être utilisé en toute sécurité.\n\nNous nous excusons de la gêne occasionnée et vous remercions de votre confiance.\n\nDECATHLON',
    'concernedProductQuantity': 'Nombre de produit non conforme :',
    'concernedProductLabel': 'Produit non conforme : ',
    'confirmation': 'Merci d’avoir répondu à ce formulaire, votre demande a bien été enregistrée. \n\nNous vous communiquerons dès que possible le n° de suivi pour la livraison de votre kit.\n\nNous vous souhaitons une bonne journée\n\nDECATHLON'
  },
  'repair': {
    'title': 'Réparation avec votre participation',
    'description': 'Nous avons détecté un risque de chute verticale du poteau dans le cas où cette manivelle serait enlevée et le produit manipulé ou utilisé sur certains paniers de basket TARMAK B900 BOX NBA ref.4239136. \nSuite à votre réponse, votre produit semble concerné par ce risque.\n\nNous vous demandons donc de ne plus l’utiliser, et proposons de vous accompagner dans l’adaptation de cette manivelle afin de pouvoir utiliser votre produit en toute sécurité.\nSoyez rassuré•es, cette réparation ne nécessite aucune expertise, tout est parfaitement indiqué dans la video explicative et notice ci-dessous: ',
    'videoLink': 'Lien Vidéo',
    'docLink': 'Lien Notice',
    'callToAction': 'Je clique ici pour recevoir gratuitement mon kit de réparation',
    'warranty': 'Toute la démarche sera couverte par notre garantie de 5 ans'
  },
  'repairRequest': {
    'title': 'Merci de saisir les informations suivantes pour que votre kit gratuit soit envoyé à l’adresse de votre choix :'
  },
  'form': {
    'submit': 'Suivant'
  },
  'status': 'Translation validated by SPORT'
} as const
